<template>
  <div class="card p-4">
    <div class="col-12 d-md-flex justify-content-lg-between mb-3 clickable" @click.prevent="toggle">
      <h4><span class="badge badge-danger"><b>{{ showing ? "--":"+"}}</b></span> Grade</h4>
    </div>

    <div class="collapse show" id="collapse-module">
      <div class="col-12 row module-grade">
        <div class="col-12 col-md-4 library sticky-top">
          <div class="mb-3">
            <button class="btn bnt-sm btn-dark" @click="addModule"><i class="fa fa-plus-circle"></i> Novo Modulo</button>
          </div>

          <div class="border-top">
            <library />
          </div>
        </div>

        <div class="col-12 col-md-8">
          <module-list v-for="item,i in modulesArray" :key="i" :course="course" :data="item" :index="i" @delete="deleteItem" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModuleList from './Grade/Module'
import Library from './Grade/Library'

export default {
  props: {
    modules: {
      required: true
    },
    course: {
      required: true
    }
  },
  components: {
    "module-list": ModuleList,
    "library": Library
  },
  data () {
    return {
      modulesArray: [],
      showing: true
    }
  },
  watch: {
    modules: {
      immediate: true,
      handler( val, old ) {
        if ( val != undefined && val != old ) {
          this.modulesArray = val
        }
      }
    }
  },
  methods: {
    toggle: function () {
      this.showing = !this.showing
      $("#collapse-module").collapse('toggle')
    },

    addModule: function () {
      this.modulesArray = [...this.modulesArray, { name: 'Novo Modulo', classes: [] }]
    },

    deleteItem: function ( index ) {
      this.modulesArray = this.modulesArray.filter( ( item,i ) => {
        return i != index
      })
    }
  }
}
</script>
